<template>
	<dms-wrapper :label="labelOdDo" show-label v-bind="{span, validationRules, ...$attrs}" :validation-property="validationPropertyCmp" :disabled="isDisabled">
		<el-row type="flex" class="frm-subgroup frm-input-group">
			<dms-date-picker :placeholder="placeholderOdText"
				:value="valueOd"
				:type="type"
				:disabled="isDisabledOd"
				:picker-options="pickerOptionsOd"
				:wrapp="false"
				:span="12"
				data-cy="dateOd"
				@update:value="$emit('update:valueOd', $event)" />
			<dms-date-picker :placeholder="placeholderDoText"
				:value="valueDo"
				:type="type"
				:disabled="isDisabledDo"
				:picker-options="pickerOptionsDo"
				:wrapp="false"
				:span="12"
				@update:value="$emit('update:valueDo', $event)" />
		</el-row>
	</dms-wrapper>
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

const TYPES = {
	year: 'Rok',
	month: 'Měsíc',
	date: 'Datum',
	dates: 'Datumy',
	datetime: 'Datum a čas',
	week: 'Týden',
};

export default BaseInput.extend({
	name: 'DmsDateOdDo',
	components: { DmsWrapper },
	props: {
		valueOd: [Date, String],
		valueDo: [Date, String],
		type: {
			type: String,
			in: Object.keys(TYPES),
			default: 'date',
		},
		disabledOd: { type: Boolean, default: undefined },
		disabledDo: { type: Boolean, default: undefined },
		placeholderOd: String,
		placeholderDo: String,
	},
	computed: {
		placeholderOdText() {
			return (
				this.placeholderOd || this.checkLocalization(this.Localize(`${this.getPlaceholderKey()}Od`))
			);
		},
		placeholderDoText() {
			return (
				this.placeholderDo || this.checkLocalization(this.Localize(`${this.getPlaceholderKey()}Do`))
			);
		},
		labelOdDo() {
			return this.label || this.LocalizeMultiKey(`${this.labelKey}/OD/DO`);
		},

		isDisabledOd() {
			if (this.disabledOd === undefined) {
				return this.disabled;
			}
			return this.disabledOd;
		},
		isDisabledDo() {
			if (this.disabledDo === undefined) {
				return this.disabled;
			}
			return this.disabledDo;
		},
		pickerOptionsDo() {
			const self = this;
			return {
				disabledDate(time) {
					return self.valueOd instanceof Date && time.getTime() < self.valueOd.getTime();
				},
			};
		},
		pickerOptionsOd() {
			const self = this;
			return {
				disabledDate(time) {
					return self.valueDo instanceof Date && time.getTime() > self.valueDo.getTime();
				},
			};
		},
	},
	methods: {
		checkLocalization(localized) {
			return localized.startsWith('??') ? this.Localize(this.labelKey) : localized;
		},
		getPlaceholderKey() {
			return this.placeholderKey || this.labelKey;
		},
	},
});
</script>
